<template>
    <el-dialog
        class="inform-dialog"
        :visible.sync="userInactive"
        width="87%"
        :center="true"
        :show-close="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="handleClose"
        title="">
        <div class="inform-dialog-body">
            <el-row style="padding: 20px 0 0 0;">
                <el-col :span="24" class="mb-4">
                    <img :src="require('@/assets/svg/warning.svg?inline')" width="120"/>
                </el-col>
                <el-col :span="24" class="mb-4">
                    <div class="inform-dialog-title">{{$t('components.inactive-member.title')}}</div>
                </el-col>
                <el-col :span="24" class="inform-dialog-text mb-4">
                    <span>{{`${$t('components.inactive-member.text-1')} ${restaurantInfo.restaurantName} ${$t('components.inactive-member.text-2')}`}}</span>
                </el-col>
            </el-row>
        </div>
        <span slot="footer">
            <el-button 
                type="primary"
                class="confirm-button"
                @click="handleClose">{{$t('components.inactive-member.confirm-button')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    methods: {
        ...mapActions({
            setUserInactive: "user/setUserInactive",
            doLogout: "auth/doLogout",
        }),
        handleClose() {
            if(this.$route.name === 'Login' || this.$route.name === 'Register') {
                this.setUserInactive(false)
            } else {
                this.doLogout().then(() => {
                    this.$router.push({ name: "Login" });
                });
            }
        }
    },
    computed: {
        ...mapGetters({
            userInactive: "user/userInactive",
            restaurantInfo: "restaurant/restaurantInfo"
        })
    }
}
</script>

<style>
.inform-dialog .el-dialog__body {
    height: fit-content;
    padding: 0px 16px 0 !important;
}

.inform-dialog .el-dialog {
    border-radius: 16px;
    max-width: 600px;
    margin-top: 25vh !important;
}

.inform-dialog-body {
    text-align: center;
    background-color: #FFFFFF;
    border-radius: 12px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
}

.inform-dialog-title {
    font-weight: 700;
    font-size: 22px;
    line-height: 24px;
    color: #333333 !important;
}

.inform-dialog-text {
    font-size: 18px;
    color: #666666 !important;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: keep-all;
    padding: 0 36px 0 36px;
}

.inform-dialog .confirm-button {
    font-family: "DB Heavent";
    font-weight: bold;
    font-size: 20px;
    width: 100%;
    height: 44px;
}
</style>
